import { Component, Input } from '@angular/core';
import { ApiCoverageDetail } from '@bhtp-client-api/base';

@Component({
    selector: 'included-coverages-list',
    template: require('./included-coverages-list.component.html')
})
export class IncludedCoveragesListComponent {
    @Input() public coverages: ApiCoverageDetail[] = [];
    @Input() public bonusCoverages: ApiCoverageDetail[] = [];
    @Input() public title: string = 'Included Coverages';
    @Input() public displayCoveragePayoutType: boolean;

    /**
     *  True if the currently loaded trip was purchased.
     *      This is needed to determine the wording to show on the bonus coverages component.
     */
    @Input() public wasPurchased: boolean = false;
    @Input() public showingPurchasedOptionalCoverages: boolean = false;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/included-coverages-list.component.ts